export default "__VITE_ASSET__BTA_9ww___"